import { ReactNode } from 'react';

export const TableHeadingRowWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <tr>{children}</tr>;
};
